import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { IStoreMenuCategoryItem, StoreService, IStoreMenuItem, ITranslatableText, IStore, IStoreMenu} from 'src/app/store/services/store.service';
import { ChangeDetectorRef } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';
import { AddressEditorModalComponent } from '../../components/address-editor-modal/address-editor-modal.component';
import { GoogleApiService } from 'src/app/shared/services/google-api.service';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
//import { Geolocation } from '@capacitor/geolocation'; // new package used here
import { IGeopoint, OrderType } from 'src/app/store/pages/list-page/list-page.component';
import { delay, finalize } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
//import { ItemBrandServiceService } from 'src/app/store/services/item-brand-service.service';
//import { ItemDetailService } from 'src/app/store/services/item-detail.service';
import { ITenantConfiguration, SettingService } from '../../services/setting.service';
import { ItemBrandServiceService } from 'src/app/store/services/item-brand-service.service';
import { IAddress } from '../../services/address.service';
import { DomSanitizer } from '@angular/platform-browser';
//import { IonSlides } from '@ionic/angular';
//import { SwiperComponent } from 'swiper/angular';
//import SwiperCore, { Navigation, Pagination } from 'swiper';
import { AlertService } from '../../services/alert.service';
import { IItemDetailCombination } from 'src/app/store/services/order.service';
import { TranslationService } from '../../services/translation.service';

interface itemDetailCombination 
{
  size: ITranslatableText,
  color: ITranslatableText,
  sizeId: string,
  colorId: string,
  id: string,
  code: string,
  isDeleted: boolean,
  price: number
}

//SwiperCore.use([Navigation, Pagination]);

@Component({
    selector: 'app-menu-item-detail-modal',
    templateUrl: './menu-item-detail-modal.component.html',
    styleUrls: ['./menu-item-detail-modal.component.scss'],
    standalone: false
})
export class MenuItemDetailModalComponent implements OnInit, AfterViewInit {
  @Input() item: IStoreMenuCategoryItem;
  @Input() store: IStore;
  @Input() orderType: OrderType;
  @Input() chosenQuantity: number;
  @Input() chosenItemDetailCombination: IItemDetailCombination;
  @Input() dismissItemModal;
  @ViewChildren('img2') img2;
  @ViewChildren('colorCircle') colorCircle;
  @ViewChildren('sizes') sizes;
  @ViewChild('imageContainer') imageContainer: ElementRef;
  @ViewChild('zoomIn') zoomIn: ElementRef;

  //SwiperCore.use([Navigation, Pagination]);
  //@ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @ViewChild('swiper', { static: false }) swiperEl?: ElementRef;

  //@ViewChild('slider') slides: IonSlides;
  isCombination: Boolean = false;
  isFoodItem: boolean;
  propertySelected: boolean = false;
  isRetailItem: boolean;
  cartOrderType: OrderType;

  itemDetailCombination: itemDetailCombination;
  selectedColor: string;
  selectedColorImage = {mainImage: '',otherImages: []};
  title: string = "ItemDetail.Details";
  currentLang: string = 'en';
  selectedImage: string = null;
  deliveryAddress: IAddress;
  style1: boolean = false;
  style2: boolean = false;
  newOrder: boolean = false;
  isAlcohol: boolean = false;
  selectedOrderType: OrderType;
  size:any[] = [];
  colors:any[] = [];
  quantity = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  combinationPrice: number = null;
  normalPrice: number;
  @Input() trackStoreId: string;
  selectedQuantity: number = 1;
  itemQuantity?: number;
  brands: any[] = [];
  ecolor = "red";
  sizeSelected: boolean = false;

  postError: boolean = false;

  constructor(private modalCtrl: ModalController,
    private router: Router,
    private storage: Storage,
    private loader: LoaderService,
    private storeService: StoreService,
    //public translateService: TranslateService,
    private alertCtrl: AlertController,
    private itemBrandService: ItemBrandServiceService,
    public settingService: SettingService,
    private googleApiService: GoogleApiService,
    private alertService: AlertService,
    public sanitizer: DomSanitizer,
    public translationService: TranslationService
    ) { }
  ngOnDestroy()
  {
    this.selectedImage = null;
    this.selectedColorImage = {mainImage: '',otherImages: []};
  }
  
  private _geopoint: IGeopoint;
  get geopoint(): IGeopoint {
    return this._geopoint;
  }

  set geopoint(value: IGeopoint) {
    this._geopoint = value;
    if (!value)
      return;

    this.store._distance = GeolocationHelpers.distance(value.latitude, value.longitude, this.store.address.latitude, this.store.address.longitude);
  }

  ngOnInit() {    
    this.combinationPrice = null;
    this.normalPrice = this.item.item.price;
    this.itemDetailCombination = {
          size: null,
          color: null,
          sizeId: null,
          colorId: null,
          code: null,
          id: null,
          isDeleted: false,
          price: this.normalPrice
    };

    this.isFoodItem = this.item.item.isFoodItem;
    this.isRetailItem = this.item.item.isRetailItem; 
    this.brands = this.itemBrandService.itemBrands.filter(brand=>brand.id == this.item.item.itemBrandId);

    if(!this.isRetailItem)
    {
      if(this.item.item.isInventoryExist)
      {
        if(this.item.item.isInventoryActive)
        {
          this.checkQuantity();
        }
      }
    }
    if(this.isRetailItem)
    {
      if(this.item.item.isInventoryExist)
      {
        this.itemQuantity = null;
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      for(let color of this.item.item.itemColors as any){
        if(!color.isDeleted){
          this.changeColor(color.name, color);
          break;
        }
      }
      if(this.chosenItemDetailCombination){
        let chosenColor = this.item.item.itemColors.find(color => color.id == this.chosenItemDetailCombination.colorId);
        this.changeColor(chosenColor.name, chosenColor, undefined, chosenColor.id);

        let chosenSize = this.item.item.itemSizes.find(size => size.id == this.chosenItemDetailCombination.sizeId);
        this.selectSize(chosenSize.abbreviation, undefined, chosenSize.id);
      }
      if(this.chosenQuantity){
        this.selectedQuantity = this.chosenQuantity;
      }
    });
  }

  getItemImage(item)
  {
    if ( item.itemImageShortName != "" && item.itemImageShortName != null) {
      return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + item.itemImageShortName) + ')'
    } else {

      return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + this.settingService.getItemPlaceHolderPath()) + ')';
    }
  }
  checkQuantity(item = null)
  {   
    let storage = JSON.parse(localStorage.getItem('cartStorage'));
 
      if(storage)
      {  let quantity = 0;
          if(!this.isRetailItem)
          {
              let result = this.item.item.quantity;
              storage.map(item => {
                  if(this.item.itemId == item.itemId)
                    {         
                      quantity += item.quantity;                  
                    }
                });
              this.itemQuantity = result- quantity;
          }
        
          else
          {
              let quantity = 0;
              let result = item.quantity;
                if(storage.length > 0)
                {
                  storage.map(storedItem => {
             
                  if(storedItem.itemDetailCombination)
                  {
                    if(item.sizeId === storedItem.itemDetailCombination.sizeId && item.colorId === storedItem.itemDetailCombination.colorId)
                    {
                       quantity += storedItem.quantity;    
                    }
                    
                  }  
                       this.itemQuantity = result - quantity;
                      })
              }
              else {
                this.itemQuantity = item.quantity;
              }
          }
      }
      else 
      {
        this.itemQuantity = item.quantity;
      }
      
  }

  noQty()
  {
    this.alertCtrl.create({
      header: this.translationService.translate('Menu.OutOfStockTitle'),
      message: this.translationService.translate('Menu.OutOfStock'),
      buttons: [
        {
          text: 'Okay',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then(al=>{
      al.present();
    });
  }

  getColorImage(color)
  {
    if (color.colorImageShortName != null && color.colorImageShortName != "") {
      return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + color.colorImageShortName) + ')';
    }   
  }

  clickedImage(image)
  {
      if(image !=null && image !=null)
    {
      this.selectedImage='url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + image) + ')';
    }
  }

  getColorImages(colorImage)
  {
    if (colorImage != "" && colorImage !=null) {

      return this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + colorImage);
    }   
  }

  zoomSmallImages(image)
  {
    return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + image) + ')'
  }

  //onStartOrder(orderType=null) {
  onStartOrder(orderType = this.orderType) {
    if(!this.sizeSelected && this.isRetailItem){
      this.postError = true;
      return;
    }
    /*
     if(orderType=='delivery')
    {
      this.storage.set('orderType',orderType);
      this.router.navigateByUrl('/stores')
      this.cancel();
      return
    }
      
    if(orderType=='pickup')
    {
      this.storage.set('orderType',orderType);
      this.router.navigateByUrl('/stores');
      this.cancel();
      return
    }
    if(orderType=='shipping')
    {
      this.storage.set('orderType',orderType);
      this.router.navigateByUrl('/stores');
      this.cancel();
      return
    }
    */

    if(!this.orderType){
      this.storage.set('orderType',orderType);
      this.router.navigateByUrl('/stores')
      this.cancel();
      return
    }

    if(this.itemQuantity == 0 && this.item.item.isInventoryExist)
    {
      this.noQty();
      return;
    }

    if(this.selectedQuantity > this.itemQuantity)
    {
      this.noQty();
      return;
    }

    if(orderType == "delivery"){
      if(localStorage.getItem("deliveryAddress") == null){
        this.cartOrderType = orderType;
        this.chooseAddress();
        return;
      }
    } else if (orderType == "shipping"){
      if(localStorage.getItem("shippingAddress") == null){
        this.cartOrderType = orderType;
        this.chooseAddress();
        return;
      }
    }
    
    if(this.item.item.isAlcohol && !this.isAlcohol){
      this.selectedOrderType = orderType;
      this.isAlcohol = true;
    }
    else if (localStorage['StoreId'] && localStorage['StoreId'] !== this.trackStoreId)
    {
        this.newOrder = true;
        this.cartOrderType = orderType;
    } 
    else
    {
      this.modalCtrl.dismiss({
        cancel: false,
        itemDetailCombination: this.item.item.isRetailItem ? this.itemDetailCombination : null,
        quantity: this.selectedQuantity,
        item: this.item,
        combinationPrice: this.combinationPrice,
        orderType: orderType
      });
    }
  }
  
  cancel() {
    this.modalCtrl.dismiss({
      cancel: true
    });
    localStorage.removeItem('editKey');
  }

  emptyCart() {
    localStorage.removeItem("TimeLimit");
    localStorage.removeItem("cartStorage");
    localStorage.removeItem("StoreId");
    this.newOrder = false;
    this.modalCtrl.dismiss({
      cancel: false,
      emptyCart: true,
      itemDetailCombination: this.item.item.isRetailItem ? this.itemDetailCombination : null,
      quantity: this.selectedQuantity,
      item: this.item,
      combinationPrice: this.combinationPrice,
      orderType: this.cartOrderType
    }); 
  }

  quantityChange(e) {
    this.selectedQuantity = e.target.value
  }

  changeItemNumber(valuechange) {
    this.selectedQuantity = this.selectedQuantity + valuechange;
    if(this.selectedQuantity < 1) {
      this.selectedQuantity = 1;
    } else if (this.selectedQuantity > 99) {
      this.selectedQuantity = 99;
    }
  }

  private createImageFromBlob(image: Blob, item: IStoreMenuItem) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      item._itemImage = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  // async fetchItemImage(item: IStoreMenuItem) {

  //   if (item.itemImageShortName != null && item.itemImageShortName != "" && item._itemImage == null) {
  //   const loader = await this.loader.create();
  //   await loader.present();
  //     this.storeService.getItemImage(item.itemImageShortName).pipe(finalize(async () => {
  //       await loader.dismiss();
  //     })).subscribe((data: any) => {
    
  //       this.createImageFromBlob(data, item);
  //     }, error => {
  //     });
  //   }
  // }

  async chooseAddress() {
    const modal = await this.modalCtrl.create({
      component: AddressEditorModalComponent,
      componentProps: {
        title: 'Store.Address',
        skipProvinceValidation: true
      },
      cssClass: 'custom-border-modal-css'
    })

    modal.onWillDismiss()
    .then(async (result) => {
      if (result.data) { 
        let address = result.data;
        this.googleApiService.getAddressGeometry(address).subscribe((result) => {
          this.geopoint = {
            latitude: result.lat,
            longitude: result.lng
          }

          this.googleApiService.getCountry(this.geopoint).subscribe((country) => {
            address.country = country;
            if(this.cartOrderType == "delivery"){
              // validate address
              let isAddressValid = false;
              if (this.store.postalCodesDelivery && this.store.postalCodesDelivery.length > 0) {
                let found = this.store.postalCodesDelivery.indexOf(address.postalCode) > -1;
                if (found) {
                  isAddressValid = found;
                }
              }
              if(!isAddressValid && this.store.deliveryZone && this.store.deliveryZone.deliveryZone != null && this.store.deliveryZone.deliveryZone.length > 0){
                // need to find a point for the current address to compare with the points
                let found = false;
                this.store.deliveryZone.deliveryZone.forEach(zone => {
                  if(this.storeService.inside(this.geopoint, zone.points)){
                    found = true;
                  }
                });
                isAddressValid = found;
              }
              // the radius is only taken in reference when no postal code are supplied
              // || ( store.isDoorDashDrive &&  this.orderType =="delivery" && store._distance <=  this.doorDashDriveAverageRadius)
              if (!isAddressValid && this.store._distance <= this.store.deliveryRadius ) {
                isAddressValid = true;
              }
              if(!isAddressValid){
                this.alertService.showTranslate('Address.InvalidAddress');
                return;
              }
            }
            if(this.cartOrderType == "delivery"){
              localStorage.setItem("deliveryAddress", JSON.stringify(address));
            } else if (this.cartOrderType == "shipping") {
              localStorage.setItem("shippingAddress", JSON.stringify(address));
            }
            this.dismissItemModal(false, this.item.item.isRetailItem ? this.itemDetailCombination : null, 
              this.selectedQuantity, this.item, this.combinationPrice, this.cartOrderType);
          });
        });
      }
    });

    await modal.present();
  }

  isAddressValid(address: IAddress): boolean {
    if(address) {
      this.googleApiService.getAddressGeometry(address).subscribe((result) => {
        this.geopoint = {
          latitude: result.lat,
          longitude: result.lng
        }
  
        if (this.store.postalCodesDelivery && this.store.postalCodesDelivery.length > 0) {
          let found = this.store.postalCodesDelivery.indexOf(address.postalCode) > -1;
          if (found) {
            return found;
          }
        }
    
        if(this.store.deliveryZone && this.store.deliveryZone.deliveryZone != null && this.store.deliveryZone.deliveryZone.length > 0){
          // need to find a point for the current address to compare with the points
          let found = false;
          this.store.deliveryZone.deliveryZone.forEach(zone => {
            if(this.storeService.inside(this.geopoint, zone.points)){
              found = true;
            }
          });
    
          return found;
        }
    
        // the radius is only taken in reference when no postal code are supplied
        // || ( store.isDoorDashDrive &&  this.orderType =="delivery" && store._distance <=  this.doorDashDriveAverageRadius)
        if (this.store._distance <= this.store.deliveryRadius ) {
          return true;
        }
        return false;
      });
    } else {
      return false;
    }
    

    
  }

  track(e: Event)
  {
    const target = e.target as HTMLInputElement;

    if(target.className=="modal-new-cart" || target.id=="no")
    {
      this.newOrder=false;
    }
  } 
  changeImage(image: string, e: Event)
  { 
    let target = e.target as Element;
    //this.slides.slideTo(+target.id);
    //this.swiper?.swiperRef.slideTo(+target.id);
    const swiper = this.swiperEl?.nativeElement.swiper;
    swiper?.slideTo(+target.id);

    let images = this.img2._results;
 
    for(let i = 0; i < images.length; i++)
    {
      images[i].nativeElement.classList.remove('style2');
      if(images[i].nativeElement.id == target.id)
      {
        target.classList.add('style2');
      }
    }
    // don't need because use scroll instead
    // this.clickedImage(image)
  }
  changeColor(color, colorAllProp, e?: Event, chosenColorId?: string): boolean
  { 
    this.initialProperty();
    if(colorAllProp.colorImagesShortNames)
    {
      this.selectedColorImage.mainImage = colorAllProp.colorImagesShortNames[0];
      this.selectedColorImage.otherImages = [...colorAllProp.colorImagesShortNames];
      this.selectedImage = 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + colorAllProp.colorImagesShortNames[0]) + ')'
      // don't need above line
      /*
      if(this.slides){
        this.slides.slideTo(0);
      }
      */

      /*
      if (this.swiper?.swiperRef) {
        this.swiper.swiperRef.slideTo(0);
      }
      */
      const swiper = this.swiperEl?.nativeElement.swiper;
      swiper?.slideTo(0);
    }
    else {
      this.selectedColorImage.otherImages.length = 0;
      this.selectedColorImage.mainImage = '';
      this.selectedImage = null;
    }
    let colors = this.colorCircle._results;
    this.selectedColor = color.translations[localStorage['lang']];

    if(e === undefined && chosenColorId === undefined){
      colors[0].nativeElement.classList.add('selected');
      this.itemDetailCombination.colorId = colors[0].nativeElement.id;
    } else {
      let id = null;
      if (e){
        let target = e.target as Element;
        id = target.id;
      } else if (chosenColorId) {
        id = chosenColorId;
      }
      for(let i = 0; i < colors.length; i++)
      {
          if(colors[i].nativeElement.id == id)
          {  
            colors[i].nativeElement.classList.add('selected');
          }
          else
          {
            colors[i].nativeElement.classList.remove('selected');
          }
      }
      this.itemDetailCombination.colorId = id;
    }
    this.itemDetailCombination.color = color;
    this.checkItemDetailCombination();
    return true;
  }
  selectSize(size, e?:Event, chosenSizeId?: string)
  { 
    this.initialProperty();
    let id = null;
    if (e){
        let target = e.target as Element;
        id = target.id;
    } else if (chosenSizeId) {
        id = chosenSizeId;
    }
    let colors = this.sizes._results;
    for(let i = 0; i < colors.length; i++)
    {
      if(colors[i].nativeElement.id == id)
      {  
        colors[i].nativeElement.classList.add('selectedSize');
      }
      else
      {
        colors[i].nativeElement.classList.remove('selectedSize');
      }
    }
    this.sizeSelected = true;
    this.postError = false;
    this.itemDetailCombination.size = size;
    this.itemDetailCombination.sizeId = id;
    this.checkItemDetailCombination();
  }

  initialProperty()
  {
    this.isCombination = false;
    this.itemDetailCombination.id = "";
    this.itemDetailCombination.code = "";
    this.itemDetailCombination.price = this.normalPrice;
    this.combinationPrice = null;
    this.propertySelected = true;
    this.itemQuantity = null;
  }
  

  checkItemDetailCombination()
  {
    
    if(this.item.item.itemDetailCombination.length > 0)
    {
      this.item.item.itemDetailCombination.map(item => {

          if(item.sizeId == this.itemDetailCombination.sizeId && item.colorId == this.itemDetailCombination.colorId && !item.isDeleted)
          {
          
            this.isCombination = true;
            this.combinationPrice = item.price;
            this.itemDetailCombination.isDeleted = item.isDeleted;
            this.itemDetailCombination.id = item.id;
            this.itemDetailCombination.price = this.combinationPrice;
            this.itemDetailCombination.code = item.code;
            this.itemQuantity = item.quantity;
            this.checkQuantity(item);
            
          }
      })    
    }
    else 
    {
      this.combinationPrice = null;
    }
  }
  zoom()
 { 
   let container = this.imageContainer.nativeElement;
   container.classList.add("hide");
   if(this.zoomIn)
   {
    let zoom = this.zoomIn.nativeElement;
    zoom.classList.remove("hide");
   }
 }
 close()
 {
  let container = this.imageContainer.nativeElement;
  container.classList.remove("hide");
  let zoom = this.zoomIn.nativeElement;
  zoom.classList.add("hide");
 }
 openAccordion(e: any)
 {  //View child yet to be configured
    e.target.classList.toggle("active");
    var panel = e.target.nextElementSibling;
    panel.classList.toggle("hide");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
 }
 openTab(){
  window.open("/home", '_blank');
 }
 
  onSlideChange(){
  /*
  this.slides.getActiveIndex().then(
    (index)=>{
      let images=this.img2._results;
 
      for(let i=0;i<images.length;i++)
      {
        images[i].nativeElement.classList.remove('style2');
        if(images[i].nativeElement.id==index)
        {
          images[i].nativeElement.classList.add('style2');
        }
      }
   });
   */

   /*
    const swiperInstance = this.swiper?.swiperRef; // Swiper instance
    if (swiperInstance) {
      const index = swiperInstance.activeIndex; // synchronous

      const images = this.img2._results;
      for (let i = 0; i < images.length; i++) {
        images[i].nativeElement.classList.remove('style2');
        if (+images[i].nativeElement.id === index) { // make sure to compare numbers
          images[i].nativeElement.classList.add('style2');
        }
      }
    }
    */
    const swiper = this.swiperEl?.nativeElement.swiper;
    if (swiper) {
      const index = swiper.activeIndex;

      const images = this.img2._results;
      for (let i = 0; i < images.length; i++) {
        images[i].nativeElement.classList.remove('style2');
        if (+images[i].nativeElement.id === index) {
          images[i].nativeElement.classList.add('style2');
        }
      }
    }
  }

  subItemClicked(subItem: IStoreMenuItem){
    this.modalCtrl.dismiss({
        cancel: false,
        quantity: this.selectedQuantity,
        subItem: subItem,
        orderType: this.orderType
      });
  }
}

